import {
  CANCEL_SUBSCRIPTION,
  FETCH_DONATION_HISTORY,
  PROCESS_DONATION,
  PROCESS_DONATION_SESSION,
  receiveDonationHistory,
  receiveDonationSessionId,
} from "@/components/donations/ducks/Actions"
import {
  apiCancelSubscription,
  apiFetchDonationHistory,
  apiProcessDonation,
  apiProcessDonationSession,
} from "@/components/donations/ducks/AJAX"

export default (store) => (next) => (action) => {
  switch (action.type) {
    case PROCESS_DONATION:
      apiProcessDonation(action.payload, action.success, action.error)
      return next(action)
    case PROCESS_DONATION_SESSION:
      apiProcessDonationSession(
        action.payload,
        action.success,
        action.error,
        receiveDonationSessionId,
      )
      return next(action)
    case FETCH_DONATION_HISTORY:
      if (!store.getState().donations.user.cacheDonations) {
        apiFetchDonationHistory(receiveDonationHistory)
      }
      return next(action)
    case CANCEL_SUBSCRIPTION:
      apiCancelSubscription(action.subscriptionId, action.success, action.error)
      return next(action)
    default:
      return next(action)
  }
}
